/**
 * CATMAN-B039 — Reconoce el rechazo del guardado por versión desactualizada.
 *
 * El backend responde 409 con keyword `PLANOGRAM_STALE_VERSION` cuando el planograma fue guardado
 * desde otra pestaña o por otro usuario después de que este editor lo cargó. No es un fallo del
 * guardado: reintentar no sirve (seguiría pisando el trabajo ajeno), la única salida es recargar.
 */
export const PLANOGRAM_STALE_VERSION_KEYWORD = 'PLANOGRAM_STALE_VERSION';

const CONFLICT_STATUS = 409;

export interface PlanogramStaleVersionInfo {
  /** Usuario que hizo el guardado vigente. */
  updatedBy: string | null;
  /** Fecha (UTC, ISO) del guardado vigente. */
  updatedOn: string | null;
}

export function isStaleVersionFailure(error?: any): boolean {
  if (error == null) return false;

  const status = Number(error?.status ?? error?.statusCode);
  if (status !== CONFLICT_STATUS) return false;

  const messages = error?.error?.responseMessages;
  if (!Array.isArray(messages)) return false;

  return messages.some(msg => msg?.keyword === PLANOGRAM_STALE_VERSION_KEYWORD);
}

export function getStaleVersionInfo(error?: any): PlanogramStaleVersionInfo {
  const body = error?.error;

  return {
    updatedBy: typeof body?.updatedBy === 'string' && body.updatedBy.trim() ? body.updatedBy.trim() : null,
    updatedOn: typeof body?.updatedOn === 'string' && body.updatedOn ? body.updatedOn : null,
  };
}
